// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date___b_sa","head":"ProcedureTableInfo_head__3B0sa"};